// next
// import Image from 'next/legacy/image';

// material-ui
import { Container, Grid, Typography } from "@mui/material";

// project import
import MainCard from "../../components/MainCard";
// import Animation from './Animation';

import {
  SlidersOutlined,
  SafetyCertificateOutlined,
  SmileOutlined,
} from "@ant-design/icons";

// assets
import imgfeature1 from "../../assets/images/landing/img-feature1.svg";
import imgfeature2 from "../../assets/images/landing/img-feature2.svg";
import imgfeature3 from "../../assets/images/landing/img-feature3.svg";

// ==============================|| LANDING - FEATURE PAGE ||============================== //

const FeatureBlock = () => (
  <Container>
    <Grid
      container
      alignItems="center"
      justifyContent="center"
      spacing={2}
      sx={{ mt: { md: 15, xs: 2.5 }, mb: { md: 10, xs: 2.5 } }}
    >
      <Grid item xs={12}>
        <Grid
          container
          spacing={1}
          justifyContent="center"
          sx={{ mb: 4, textAlign: "center" }}
        >
          <Grid item sm={10} md={6}>
            <Grid container spacing={1} justifyContent="center">
              <Grid item xs={12}>
                <Typography variant="h2" sx={{ mb: 2 }}>
                  Nossos Diferenciais
                </Typography>
              </Grid>
              {/* <Grid item xs={12}>
                <Typography variant="body1">
                  Customize everything with the Mantis React Material-UI
                  Dashboard Template built with latest MUI v5 component library
                </Typography>
              </Grid> */}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        {/* <Animation
          variants={{
            hidden: { opacity: 0, translateY: 550 },
            visible: { opacity: 1, translateY: 0 }
          }}
        > */}
        <MainCard contentSX={{ p: 3 }}>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              {/* <img src={imgfeature1} alt="feature" width={48} height={48} /> */}
              <SafetyCertificateOutlined
                style={{ fontSize: "30px", color: "green" }}
              />
            </Grid>
            <Grid item xs={12}>
              <Typography variant="h5" sx={{ fontWeight: 600, mt: 2 }}>
                Segurança
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="h5" color="#8c8c8c">
                Certificado ISO-30107-3 e 0% de FAR.
              </Typography>
            </Grid>
          </Grid>
        </MainCard>
        {/* </Animation> */}
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        {/* <Animation
          variants={{
            hidden: { opacity: 0, translateY: 550 },
            visible: { opacity: 1, translateY: 0 }
          }}
        > */}
        <MainCard contentSX={{ p: 3 }}>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              {/* <img src={imgfeature2} alt="feature" width={48} height={48} /> */}
              <SmileOutlined style={{ fontSize: "30px" }} />
            </Grid>
            <Grid item xs={12}>
              <Typography variant="h5" sx={{ fontWeight: 600, mt: 2 }}>
                Usabilidade
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="h5" color="#8c8c8c">
                Interface intuitiva sem comprometer a proteção.
              </Typography>
            </Grid>
          </Grid>
        </MainCard>
        {/* </Animation> */}
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        {/* <Animation
          variants={{
            hidden: { opacity: 0, translateY: 550 },
            visible: { opacity: 1, translateY: 0 }
          }}
        > */}
        <MainCard contentSX={{ p: 3 }}>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              {/* <img src={imgfeature3} alt="feature" width={48} height={48} /> */}
              {/* //@ts-ignore */}
              <SlidersOutlined style={{ fontSize: "30px", color: "blue" }} />
            </Grid>
            <Grid item xs={12}>
              <Typography variant="h5" sx={{ fontWeight: 600, mt: 2 }}>
                Customização
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="h5" color="#8c8c8c">
                Adapte-se às suas necessidades específicas
              </Typography>
            </Grid>
          </Grid>
        </MainCard>
        {/* </Animation> */}
      </Grid>
    </Grid>
  </Container>
);
export default FeatureBlock;
